import React from 'react'
import PropTypes from 'prop-types'
import { useHasCreateRevisionRight } from 'components/feature/FeatureRevision/useFeatureRevision'

export const FeatureGroupContext = React.createContext()

export default function FeatureGroup({ children, name = null, featureId }) {
  const hasAccess = useHasCreateRevisionRight(featureId)

  if (name === null) return children

  if (!hasAccess) {
    return null
  }

  return (
    <FeatureGroupContext.Provider value={{ name }}>
      {children}
    </FeatureGroupContext.Provider>
  )
}

FeatureGroup.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  featureId: PropTypes.string,
}
